
















































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { AppState } from '@/store/types/app';
import Sight from './Sight.vue';
import { DeviceType } from '../../store/types/app';

@Component({
  components: {
    Sight
  }
})
export default class Banner extends Vue {
  @Action('setSightMeasure', { namespace: 'app' }) private setSightMeasure: any;
  @Action('togglePopup', { namespace: 'app' }) private togglePopup: any;
  @Action('togglePopupContent', { namespace: 'app' }) private togglePopupContent: any;
  @Getter('device', { namespace: 'app' }) private device: any;
  @Getter('theme', { namespace: 'app' }) private theme: any;
  @Getter('sight', { namespace: 'app' }) private sight: any;
  @Getter('submitInfo', { namespace: 'template' }) private submitInfo: any;
  @Getter('openSubmit', { namespace: 'template' }) private openSubmit: any;
  @Getter('loudly', { namespace: 'template' }) private loudly: any;

  @Watch('device')
  public onDeviceChanged (val: string, newVal: string) {
    this.measureSightSize();
  }

  public mounted () {
    this.measureSightSize();

    window.addEventListener('resize', this.measureSightSize);
  }

  public destroyed () {
    window.removeEventListener('resize', this.measureSightSize);
  }

  private measureSightSize (): void {
    const sightContainer: any = this.$refs.sightContainer;

    const sightOffset: number = sightContainer.offsetTop;
    const boxCols: number = this.device === DeviceType.MOBILE ? Math.floor((sightContainer.clientWidth + 12) / 100) : 8;
    const boxRows: number = 3;
    const boxGap = this.device === DeviceType.MOBILE ? 27 : 40;
    const boxWidth: number = (sightContainer.clientWidth - boxGap * (boxCols - 1)) / boxCols;
    const boxHeight: number = boxWidth;
    const containerWidth: number = boxWidth * boxCols + boxGap * (boxCols - 1);
    const containerHeight: number = boxHeight * boxRows + boxGap * (boxRows - 1);

    this.setSightMeasure({
      offset: sightOffset,
      containerWidth,
      containerHeight,
      width: boxWidth,
      height: boxHeight,
      cols: boxCols,
      rows: boxRows,
      gap: boxGap
    });
  }

  private processPopup (hook: string): void {
    this.$router.push({ query: { popUp: hook } });
  }
}
